// AWS Amplify configuration for v6
// This will be populated with actual values during deployment
const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true,
        username: true
      }
    }
  },
  API: {
    REST: {
      api: {
        endpoint: process.env.REACT_APP_API_URL || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
      }
    }
  }
};

export default awsconfig;